// 回到顶部悬浮按钮
document.addEventListener('DOMContentLoaded', function() {
    // 定义监听滚动事件的函数
    function handleScroll() {
      var scrollButton = document.getElementById('ls-back');
      if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
        if(scrollButton){
          scrollButton.style.display = 'block';
        }
      } else {
        if(scrollButton){
          scrollButton.style.display = 'none';
        }
      }
    }
  
    // 页面加载时执行一次，初始化按钮状态
    // handleScroll();
  
    // 监听滚动事件
    window.addEventListener('scroll', handleScroll);
  });
  
  $(window).on('load', function() {
    var backClickButton = document.getElementById('ls-back');
    if(backClickButton) {
      backClickButton.addEventListener('click', function(e) {
      e.preventDefault();
      $('html, body').animate({scrollTop: 0}, '300');
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      })
    }
  })